import { css } from '@mui/material'
import { platformTheme } from '../theme'

export const GlobalStyles = css`
    *,
    body {
        font-family: ${platformTheme.typography.fontFamily};
    }
`
